import { clearSession } from "@/helper/auth";
import { fripickBaseUrl} from "./constants";

export const redirectToProviderWhenUnauthorizedInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                window.alert("Tu sesión ha expirado. Por favor, vuelve a iniciar sesión.");
                clearSession();
                window.open(fripickBaseUrl, "_self");
            }
            return Promise.reject(error);
        },
    );
};
